import React from "react"
import { has } from "lodash"
import { v4 as uuidv4 } from "uuid"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSpinner, faClock, faCheck, faTimes, faRetweet } from "@fortawesome/free-solid-svg-icons"
import { Modal, Box } from "@mui/material"

class AddNewReleaseConfig extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: "",
            releasePercentage: 0,
            selectedProjectVersion: null,
            showProjectVersionDropdown: false,
            showConfirmSumit: false,
            patchDataBuildStatus: null,
            showSubmitRelease: false,
        }
        this.timeOutId = null
        this.projectVersionDropDownRef = React.createRef()
    }
    handleSubmit = (e) => {
        e.preventDefault()
        if (this.validate()) {
            fetch(`/api/data/project/${this.props.projectId}/release`, {
                method: "post",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    code: this.state.selectedProjectVersion.code,
                    editorVersion: this.props.selectedEngineVersion,
                    releasePercentage: this.state.releasePercentage,
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (has(data, "error")) { throw data }
                    this.props.getCurrentRelease(this.props.selectedEngineVersion)
                })
                .catch(data => this.setState({ error: `Server: ${data.error}` }))
        }
        this.setState({ showConfirmSumit: false });
    }
    validate = () => {
        if (this.state.selectedProjectVersion === null) {
            this.setState({ error: "Select a version!" })
            return false
        }
        return true
    }
    submitProjectVersionDropDownValue = (version) => {
        this.setState({
            selectedProjectVersion: version,
            showProjectVersionDropdown: false,
            patchDataBuildStatus: null,
            showSubmitRelease: false,
        })
        this.getPatchDataBuildStatus(version.id);
    }
    getPatchDataBuildStatus = (version) => {
        this.setState({
            showProjectVersionDropdown: false,
            patchDataBuildStatus: null,
            showSubmitRelease: false,
        })
        fetch(`/assetbundles/check_patch_data_build?target_version=${version}`)
            .then(res => res.json())
            .then(data => {
                if (has(data, "error")) { throw data }
                const platforms = this.props.appConfig.platforms.split(',');
                let flag = true;
                if (Object.keys(data).length === 0) {
                    flag = false;
                } else {
                    for (const versionStatus of Object.values(data)) {
                        for (const platform of platforms) {
                            // We skip `WEBGL` for now, since we don't have webgl release, and we don't build webgl asset bundle.
                            if (platform.toUpperCase() === 'WEBGL') {
                                continue;
                            }
                            if (versionStatus[platform.toUpperCase()] !== 2) {
                                flag = false;
                                break;
                            }
                        }
                        if (!flag) {
                            break;
                        }
                    }
                }
                this.setState({
                    patchDataBuildStatus: data,
                    showSubmitRelease: flag,
                })
            })
            .catch(data => this.setState({ error: `Server: ${data}` }))
    }
    toggleProjectVersionDropDown = (e) => {
        this.setState(prevState => {
            return {
                showProjectVersionDropdown: !prevState.showProjectVersionDropdown
            }
        })
    }
    hideDropDown = (e) => {
        if (this.state.showProjectVersionDropdown === true && !this.projectVersionDropDownRef.current.contains(e.target)) {
            this.setState({
                showProjectVersionDropdown: false
            });
        }
    }
    onFocusHandler() {
        clearTimeout(this.timeOutId);
    }
    componentDidMount() {
        window.addEventListener("click", this.hideDropDown)
    }
    componentWillUnmount() {
        window.removeEventListener("click", this.hideDropDown)
    }
    handleReleasePercentage = e => {
        this.setState({releasePercentage: e.target.value});
    }
    handleShowConfirmSumit = (e) => {
        e.preventDefault();
        this.setState({ showConfirmSumit: true })
    }
    refreshPatchDataBuildStatus = () => {
        if (!this.state.selectedProjectVersion) {
            return;
        }
        this.getPatchDataBuildStatus(this.state.selectedProjectVersion.id)
    }
    formatStaturByStatusCode = (baseVersion, platform) => {
        if (!this.state.patchDataBuildStatus) {
            return;
        }
        const code = this.state.patchDataBuildStatus[baseVersion][platform]
        const baseVersionId = this.state.patchDataBuildStatus[baseVersion]["id"]
        const self = this
        const requestBuild = () => {
            fetch(`/assetbundles/request_download_internal?base_version=${baseVersionId}&target_version=${this.state.selectedProjectVersion.id}&platform=${platform}`)
                .then(res => res.json())
                .then(data => {
                    if (has(data, "error")) { throw data }
                    // Re-fetch the asset patch data build status
                    setTimeout(function() {
                        self.refreshPatchDataBuildStatus()
                    }, 1000);
                })
                .catch(data => this.setState({ error: `Server: ${data.error}` }))
        }
        switch(code){
            case 0:
                return <h5 className="col pending"><FontAwesomeIcon icon={faClock}/>&nbsp;<a>Pending</a></h5>
            case 1:
                return <h5 className="col running"><FontAwesomeIcon icon={faClock} />&nbsp;<a>Building</a></h5>
            case 2:
                return <h5 className="col success"><FontAwesomeIcon icon={faCheck} />&nbsp;<a>Success</a></h5>
            case 3:
                return <h5 className="col failed"><FontAwesomeIcon icon={faTimes} />&nbsp;<a>Failed</a>&nbsp;<FontAwesomeIcon icon={faRetweet} />&nbsp;<a onClick={requestBuild}>Generate</a></h5>
            default:
                return <h5 className="col canceled"><FontAwesomeIcon icon={faTimes} />&nbsp;<a>NONE</a>&nbsp;<FontAwesomeIcon icon={faRetweet} />&nbsp;<a onClick={requestBuild}>Generate</a></h5>
        }
    }
    render() {
        if (this.props.initialLoad === true) return <div className="loading"><FontAwesomeIcon icon={faSpinner} spin /></div>
        const { error, showConfirmSumit, selectedProjectVersion, showProjectVersionDropdown, patchDataBuildStatus, showSubmitRelease } = this.state;
        const partialReleaseOptions = [0, 1, 2, 5, 10, 20, 50, 99, 100];
        const platforms = this.props.appConfig.platforms.split(',');
        const style = {
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: 800,
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            border: '0px solid #000',
            outline: 0,
            boxShadow: 24,
            p: 4,
        };
        return (
            <div>
                <div className="buildConfigForm">
                    {
                        error &&
                            <p className="error">{error}</p>
                    }
                    <Modal
                        open={showConfirmSumit}
                        closeAfterTransition
                        onClose={() => this.setState({ showConfirmSumit: false })}
                    >
                        <Box sx={style}>
                            <div className="requestForm" style={{fontFamily: "Montserrat,proxima-nova,sans-serif"}}>
                                <div style={{fontSize: "4rem", fontFamily: "inherit", color: "#ff0000"}}>Warning:</div>
                                <div style={{fontSize: "2rem", fontFamily: "inherit", color: "#000000"}}>After clicking 'Confrim Submit' button, this asset bunlde patch will roll out to production!</div>
                                <a href="https://www.notion.so/funovus/Asset-Bundle-Patch-Doc-f0bfda13063f47169298855b04315c48" target="_blank" rel="noopener noreferrer" style={{fontSize: "2rem", fontFamily: "inherit"}} >Asset Bundle Patch Document</a>
                                <div className="buttonGroup" style={{textAlign: "right"}}>
                                    <button className="submitBtn" onClick={this.handleSubmit}>
                                        Confrim Submit
                                    </button>
                                    <button className="cancelBtn" onClick={() => this.setState({ showConfirmSumit: false })}>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </Box>
                    </Modal>
                    {
                        this.props.selectedEngineVersion &&
                            <div className="col-2">
                                <div>
                                    Patch Target Version:&nbsp;
                                </div>
                                <div className="dropdownContainer" tabIndex="0" ref={this.projectVersionDropDownRef}
                                    aria-expanded={showProjectVersionDropdown}>
                                    {this.props.history.length > 0
                                        ? <div className="dropdownHeader" onClick={this.toggleProjectVersionDropDown}>{selectedProjectVersion === null ? "Select a version to release!" : `Project Version: ${selectedProjectVersion.name}`}
                                            <title>Open drop down</title>
                                        </div>
                                        : <div className="dropdownHeader disabled">Publish a version in DreamEditor first!</div>}
                                    <div className={`dropdownContent ${showProjectVersionDropdown === false ? "hidden" : ""}`}>
                                        <div className="normalOption" role="listbox">
                                            {this.props.history.filter((x) => x.editorVersion === this.props.selectedEngineVersion).map((version) =>
                                                <div className="option" key={uuidv4()} aria-label={version.name} tabIndex="0" aria-hidden="true" aria-selected="false" role="option" onClick={() => this.submitProjectVersionDropDownValue(version)}>
                                                    {`Version: ${version.name}`}
                                                </div>)}
                                        </div>
                                        {this.props.isLoading
                                            ? <div className="loading option"><FontAwesomeIcon icon={faSpinner} spin /></div>
                                            : null}
                                        {this.props.loadMore
                                            ? <div className="option" aria-hidden="true" aria-selected="false" role="option" onClick={this.props.loadMoreOnClick} tabIndex="0">Load more... </div>
                                            : null}
                                    </div>
                                </div>
                            </div>
                    }
                    {
                        this.props.selectedEngineVersion && selectedProjectVersion && showSubmitRelease &&
                        <div className="col">
                            <select value={this.state.releasePercentage} onChange={this.handleReleasePercentage}>
                                {
                                    partialReleaseOptions.map(p => <option key={p} value={p}>{p}</option>)
                                }
                            </select>
                            % Release
                        </div>
                    }
                    {
                        this.props.selectedEngineVersion && selectedProjectVersion && showSubmitRelease &&
                        <div className="col">
                            <div className="buttonGroup">
                                <button className="submitBtn" onClick={this.handleShowConfirmSumit}>
                                    Submit
                                </button>
                                <button className="cancelBtn" onClick={this.props.cancelNewRelease}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    }
                    {
                        this.props.selectedEngineVersion && selectedProjectVersion && !showSubmitRelease &&
                        <div className="col">
                            <div  style={{fontSize: "1rem", fontFamily: "inherit", color: "#ff0000"}}>
                                To rollout a patch, there must be at least one production released patch base version that is smaller than the target version,
                                and all platforms patch data for all production released patch base versions must be generated.
                            </div>
                        </div>
                    }
                </div>
                {
                    this.props.selectedEngineVersion && selectedProjectVersion &&
                    <div className="formWrapper">
                        <div className="col">
                            <div>
                                Asset Bundle Patch Data Status&nbsp;
                                <button className="submitBtn" type="button"  onClick={this.refreshPatchDataBuildStatus}>
                                    Refresh
                                </button>
                            </div>
                        </div>
                        <div className="buildConfigForm">
                            <h5 className="col title">Production Release Version</h5>
                            {
                                platforms.map(p => <h5 className="col title">{p.toUpperCase()}</h5>)
                            }
                        </div>
                        {patchDataBuildStatus &&
                            Object.keys(patchDataBuildStatus).map((baseVersion) => {
                                return <div className="buildConfigForm">
                                    <h5 className="col">{baseVersion}</h5>
                                    {
                                        platforms.map(p => this.formatStaturByStatusCode(baseVersion, p.toUpperCase()))
                                    }
                                </div>
                            })
                        }
                    </div>
                }
            </div>
        )
    }
}

export default AddNewReleaseConfig